/**
 * Thread message pagination constants
 * Adjust MESSAGE_PAGE_SIZE to test pagination behavior
 */

/** Number of messages to load per page/batch */
export const MESSAGE_PAGE_SIZE = 25;

/** Number of messages to load on initial thread fetch */
export const INITIAL_MESSAGE_LIMIT = 50;
